/**
* @Author: zachalam
* @Date:   2017-02-08T12:01:02-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-08T12:01:02-08:00
*/

import _ from 'lodash';

let initialState = {

};

/* stores logged in profile */
const extprofile = (state = initialState, action) => {
  switch(action.type) {
    case 'STORE_PROFILE_EXTERNAL':
      return {
        ...state,
        ...action.payload
      };

    case 'REMOVE_PROFILE_EXTERNAL':
      return { };

    case 'STORE_PROFILE_FAV_CHANGE':
      // add/remove profile favorite (when viewing profile)
      let is_favorite = (state.is_favorite === null) ? true : null;
      return {
        ...state,
        is_favorite
      }
    case 'JOIN_TRIP_EXTPROFILE':
      // likes (ask to join) a trip.
      var newTripData = _.map(state.trip.data,(v)=>{return v; });
      newTripData[action.payload].is_liked = true;

      return {
        ...state,
        trip: { data: newTripData }
      }
    case 'TOGGLE_BLOCK_USER_PROFILE':
      // toggle block user profile.
      let is_blocked = (state.is_blocked === null) ? true : null;
      return {
        ...state,
        is_blocked
      }

    default:
      return state;
  }


}


export default extprofile;



// WEBPACK FOOTER //
// ./src/reducers/extprofile.js